import { Action } from '@ngrx/store';
import { OffroadTrailType } from '@polaris-customerweb/sharedcomponents.core';
import { LayerVisibilityState } from './layer-visibility.reducer';

export const LayerVisibilityAction = {
    getLayerVisibility: '[map] get layer visibility',
    setIsShowingAdventures: '[map] set is showing adventures',
    setIsShowingDealers: '[map] set is showing dealers',
    setIsShowingDesignatedPavedTrails:
        '[map] set is showing Designated Paved Trails',
    setIsShowingDesignatedUnpavedTrails:
        '[map] set is showing Designated Unpaved Trails',
    setIsShowingFood: '[map] set is showing food',
    setIsShowingFuel: '[map] set is showing fuel',
    setIsShowingGeofences: '[map] set is showing areas',
    setIsShowingInProgressRideTrack: '[map] set is showing in progress ride',
    setIsShowingLodging: '[map] set is showing lodging',
    setIsShowingPlannedRides: '[map] set is showing planned rides',
    setIsShowingPublicWaypoints: '[map] set is showing public waypoints',
    setIsShowingRideAreas: '[map] set is showing ride areas',
    setIsShowingTrackedRides: '[map] set is showing tracked rides',
    setIsShowingTrails: '[map] set is showing Trails',
    setIsShowingUnknown: '[map] set is showing unknown',
    setIsShowingUnmaintainedTrails: '[map] set is showing Unmaintained Trails',
    setIsShowingWaypoints: '[map] set is showing waypoints',
    setLayerVisibility: '[map] set layer visibility',
    setMaxRideConditionAgeInHours:
        '[ride condition] set max ride condition age in hours',
    setShouldShowCloudCover: '[map] set should show cloud cover',
    setShouldShowHeatmap: '[map] set should show heatmap',
    setShouldShowLand: '[map] set should show land',
    setShouldShowLayerMenu: '[map] set should show layer menu',
    setShouldShowRadar: '[map] set should show radar',
    setShouldShowRideCondition: '[map] set should show ride condition',
    setShouldShowSatellite: '[map] set should show satellite',
    setShouldShowSnowDepth: '[map] set should show snow depth',
    setShouldShowTrailDifficulty: '[map] set should show trail difficulty',
    setSnapToTrackedRideEnabled: '[map] set snap to Tracked Ride enabled',
    setSnapToTrailEnabled: '[map] set snap to Trail enabled',
    setTrailFilter: '[map] set trail filter',
    showTrailTypeChooser: '[map] show trail type chooser',
    toggleShouldShowMapLayersMenu: '[map] toggle should show map layer menu',
};

export class SetIsShowingDealers implements Action {
    type = LayerVisibilityAction.setIsShowingDealers;
    constructor(public isShowing: boolean) {}
}

export class SetIsShowingAdventures implements Action {
    type = LayerVisibilityAction.setIsShowingAdventures;
    constructor(public isShowing: boolean) {}
}

export class SetIsShowingPlannedRides implements Action {
    type = LayerVisibilityAction.setIsShowingPlannedRides;
    constructor(public isShowing: boolean) {}
}

export class SetIsShowingFood implements Action {
    type = LayerVisibilityAction.setIsShowingFood;
    constructor(public isShowing: boolean) {}
}

export class SetIsShowingFuel implements Action {
    type = LayerVisibilityAction.setIsShowingFuel;
    constructor(public isShowing: boolean) {}
}

export class SetIsShowingLodging implements Action {
    type = LayerVisibilityAction.setIsShowingLodging;
    constructor(public isShowing: boolean) {}
}

export class SetIsShowingUnknown implements Action {
    type = LayerVisibilityAction.setIsShowingUnknown;
    constructor(public isShowing: boolean) {}
}
export class SetIsShowingGeofences implements Action {
    type = LayerVisibilityAction.setIsShowingGeofences;
    constructor(public isShowing: boolean) {}
}

export class SetIsShowingPublicWaypoints implements Action {
    type = LayerVisibilityAction.setIsShowingPublicWaypoints;
    constructor(public isShowing: boolean) {}
}

export class SetIsShowingRideAreas implements Action {
    type = LayerVisibilityAction.setIsShowingRideAreas;
    constructor(public isShowing: boolean) {}
}

export class SetIsShowingTrackedRides implements Action {
    type = LayerVisibilityAction.setIsShowingTrackedRides;
    constructor(public isShowing: boolean) {}
}

export class SetIsShowingInProgressRideTrack implements Action {
    type = LayerVisibilityAction.setIsShowingInProgressRideTrack;
    constructor(public isShowing: boolean) {}
}

export class SetIsShowingWaypoints implements Action {
    type = LayerVisibilityAction.setIsShowingWaypoints;
    constructor(public isShowing: boolean) {}
}

export class SetShouldShowCloudCover implements Action {
    type = LayerVisibilityAction.setShouldShowCloudCover;
    constructor(public shouldShow: boolean) {}
}

export class SetShouldShowLayerMenu implements Action {
    type = LayerVisibilityAction.setShouldShowLayerMenu;
    constructor(public shouldShow: boolean) {}
}

export class SetShouldShowRadar implements Action {
    type = LayerVisibilityAction.setShouldShowRadar;
    constructor(public shouldShow: boolean) {}
}

export class SetShouldShowLand implements Action {
    type = LayerVisibilityAction.setShouldShowLand;
    constructor(public shouldShow: boolean) {}
}

export class SetShouldShowRideCondition implements Action {
    type = LayerVisibilityAction.setShouldShowRideCondition;
    constructor(public shouldShow: boolean) {}
}

export class SetMaxRideConditionAgeInHours implements Action {
    type = LayerVisibilityAction.setMaxRideConditionAgeInHours;
    constructor(public maxRideConditionAgeInHours: number) {}
}

export class SetShouldShowSatellite implements Action {
    type = LayerVisibilityAction.setShouldShowSatellite;
    constructor(public shouldShow: boolean) {}
}

export class SetShouldShowSnowDepth implements Action {
    type = LayerVisibilityAction.setShouldShowSnowDepth;
    constructor(public shouldShow: boolean) {}
}

export class SetShouldShowTrailDifficulty implements Action {
    type = LayerVisibilityAction.setShouldShowTrailDifficulty;
    constructor(public shouldShow: boolean) {}
}

export class SetShouldShowHeatmap implements Action {
    type = LayerVisibilityAction.setShouldShowHeatmap;
    constructor(public shouldShow: boolean) {}
}

export class SetLayerVisibility implements Action {
    type = LayerVisibilityAction.setLayerVisibility;
    constructor(public layerVisibility: LayerVisibilityState) {}
}
export class GetLayerVisibility implements Action {
    type = LayerVisibilityAction.getLayerVisibility;
}

export class SetIsShowingDesignatedUnpavedTrails implements Action {
    type = LayerVisibilityAction.setIsShowingDesignatedUnpavedTrails;
    constructor(public isShowing: boolean) {}
}

export class SetIsShowingDesignatedPavedTrails implements Action {
    type = LayerVisibilityAction.setIsShowingDesignatedPavedTrails;
    constructor(public isShowing: boolean) {}
}

export class SetIsShowingUnmaintainedTrails implements Action {
    type = LayerVisibilityAction.setIsShowingUnmaintainedTrails;
    constructor(public isShowing: boolean) {}
}

export class SetIsShowingTrails implements Action {
    type = LayerVisibilityAction.setIsShowingTrails;
    constructor(public isShowing: boolean) {}
}

export class SetTrailFilter implements Action {
    type = LayerVisibilityAction.setTrailFilter;
    constructor(public trailFilter: OffroadTrailType | undefined) {}
}

export class SetSnapToTrackedRideEnabled implements Action {
    type = LayerVisibilityAction.setSnapToTrackedRideEnabled;
    constructor(public isShowing: boolean) {}
}

export class SetSnapToTrailEnabled implements Action {
    type = LayerVisibilityAction.setSnapToTrailEnabled;
    constructor(public isShowing: boolean) {}
}

export class ShowTrailTypeChooser implements Action {
    type = LayerVisibilityAction.showTrailTypeChooser;
    constructor(public isShowing: boolean) {}
}
